<script>
export default {
  props: ['islogin','adiSoyadi','genelMudurlukAdi'],
}
</script>

<template>
  <header>
    <div class="container-fluid container-lg p-3 p-xl-5 pb-0">
      <div class="row">
        <div class="col-12">
          <div class="headerLeft">
            <router-link to="/">
              <img src="@/assets/images/logo.png" class="img-fluid" alt="Meb Takvim">
            </router-link>
          </div>


          <div class="headerRight">

            <p class="float-start"><strong>{{adiSoyadi}}</strong><br> {{genelMudurlukAdi}}</p>

            <a href="https://mebbissso.meb.gov.tr/ssologinBIDB.aspx?id=176" class="loginBtn" v-if="!islogin">
              <img src="@/assets/images/giris.svg" alt=""><br>
              Giriş</a>

            <a href="https://takvim.meb.gov.tr/api/guvenli_cikis.php" class="loginBtn" v-else>
              <img src="@/assets/images/cikis.svg" alt=""><br>
              Çıkış</a>


            <img src="@/assets/images/takvim2025.png" class="mT2025" style="margin-top: -12px" alt="">
          </div>
        </div>
      </div>
    </div>

  </header>
</template>

<style scoped>
  .headerLeft{float: left}
  .headerRight{float: right}
  .headerRight p {
    margin-right: 35px;
    text-align: right;
    margin-top: 9px;
    font-weight: 300;
  }
  .headerRight p strong {
    font-weight: bold;
  }

  @media (max-width: 768px) {
    .mT2025{
      display: none;
    }
  }
</style>